import TextField from "../../../components/fields/textField/TextField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
export default {
  name: "CalendarioFerias",

  components: {
    TextField,
    SelectField,
    PeriodoField
  },

  data: () => ({
    headers: [
      { text: "Decênio", value: "perfil", sortable: false },
      { text: "Quinquênio", value: "exercicio", sortable: false },
      { text: "Data Deferimento", value: "peridoFerias", sortable: false },
      { text: "Dias Cassados", value: "PeriodoSanguedoacao", sortable: false },
      { text: "Periodo Cassado", value: "diasCassados", sortable: false },
      { text: "Dias Conversão", value: "diasGozados", sortable: false },
      { text: "Dias Gozo", value: "DiasVantagem", sortable: false },
      { text: "Dias Vantagem", value: "jusAbono", sortable: false },
      { text: "Dias Restantes", value: "TP", sortable: false },
      { text: "Saldo para Gozo", value: "unid", sortable: false },
    ],

    items: [],
    page: 1,
    pageCount: 0,

    selected: [],
    selectedAction: {},
    singleSelect: false,
    idSelected: null,
    ferias:[],

    filter: {},

    optionsFilter: {
    },

    loading: {
      table: false,
      btn: false,
      field: false,
    }
  }),

  beforeMount() {
    this.ferias = this.$route.params.ferias 

  },

  mounted() {
  },

  filters: {
    
  },

  watch: {
  },

  methods: {
    trocarHistoricoFerias(name){
      this.$router.push({ name: name, params:{ferias: this.ferias} })
    },
  }
};